import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import type { Section } from '@omni/ai/features/card.schema';

/** An `entities` section's items — tappable contact/account mini-cards. */
type EntityItem = Extract<Section, { type: 'entities' }>['items'][number];

/**
 * Tappable contact/account mini-cards. `entityIcon` resolves the Ionic icon name
 * per entity kind. The `openEntity` output carries `{kind,id}` upstream; the id
 * is passed through untouched and never shown to the user.
 */
@Component({
  selector: 'card-entities',
  standalone: true,
  imports: [CommonModule, IonicModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './card-entities.component.html',
  styleUrls: ['./card-entities.component.scss'],
})
export class CardEntitiesComponent {
  @Input() title: string | null = null;
  @Input() items: EntityItem[] = [];

  @Output() openEntity = new EventEmitter<{ kind: 'contact' | 'account'; id: string }>();

  trackEntity(_i: number, item: EntityItem): string {
    return item.kind + ':' + item.id;
  }

  entityIcon(kind: EntityItem['kind']): string {
    return kind === 'contact' ? 'person-circle-outline' : 'business-outline';
  }

  onEntityTap(item: EntityItem): void {
    this.openEntity.emit({ kind: item.kind, id: item.id });
  }

  onEntityKeydown(event: KeyboardEvent, item: EntityItem): void {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.onEntityTap(item);
    }
  }
}
